import {createDefaultSmileys, SurveySmileyForm} from './surveyRatingOptions';

/** Shared Survey popup content defaults. Supports tokens listed in SURVEY_PLACEHOLDER_LABELS. */
export const SURVEY_POPUP_DEFAULTS = {
  welcomeHeading: 'Thank you {FirstName}',
  welcomeMessage:
    'Thank you {FirstName} for using SpendSail to track your corporate expenses. We would appreciate your feedback',
  actionHeading: 'Hi {FirstName} — Help us improve',
  actionMessage:
    'Tell us what went wrong and what we should improve. Your feedback guides our next updates.',
};

export const SURVEY_DEFAULT_QUESTIONS = [
  'How would you rate your experience with SpendSail?',
];

export const SURVEY_DEFAULT_REASONS = [
  'Hard to use',
  'Missing features',
  'Performance issues',
  'Support experience',
  'Other',
];

export type SurveyCampaignQuestionForm = {
  tempId: string;
  text: string;
  showSmileys: boolean;
  smileys: SurveySmileyForm[];
  reasons: string[];
};

let _surveyQTemp = 0;
export const nextSurveyQuestionTempId = () => `sq-${Date.now()}-${++_surveyQTemp}`;

export const createDefaultCampaignQuestion = (
  text = SURVEY_DEFAULT_QUESTIONS[0]
): SurveyCampaignQuestionForm => ({
  tempId: nextSurveyQuestionTempId(),
  text,
  showSmileys: true,
  smileys: createDefaultSmileys(),
  reasons: [...SURVEY_DEFAULT_REASONS],
});

export const SURVEY_PREVIEW_DEFAULT_REASONS = SURVEY_DEFAULT_REASONS.map((reason, i) => ({
  surveyReasonId: i + 1,
  reason,
  surveyQuestionId: 0,
}));

export const SURVEY_PLACEHOLDER_LABELS = [
  '{FirstName}',
  '{LastName}',
  '{Email}',
  '{RoleName}',
  '{DesignationName}',
  '{DepartmentName}',
] as const;

export type SurveyPlaceholderValues = {
  FirstName?: string | null;
  LastName?: string | null;
  Email?: string | null;
  RoleName?: string | null;
  DesignationName?: string | null;
  DepartmentName?: string | null;
};

export const replaceSurveyTokens = (
  template: string | undefined | null,
  values: SurveyPlaceholderValues
) => {
  const map: Record<string, string> = {
    FirstName: (values.FirstName || '').trim() || 'there',
    LastName: (values.LastName || '').trim() || '',
    Email: (values.Email || '').trim() || '',
    RoleName: (values.RoleName || '').trim() || '',
    DesignationName: (values.DesignationName || '').trim() || '',
    DepartmentName: (values.DepartmentName || '').trim() || '',
  };

  return String(template || '').replace(/\{([A-Za-z]+)\}/g, (match, key: string) => {
    const found = Object.keys(map).find((k) => k.toLowerCase() === key.toLowerCase());
    return found ? map[found] : match;
  });
};

/** @deprecated Use replaceSurveyTokens */
export const replaceSurveyFirstName = (template: string | undefined | null, firstName: string) =>
  replaceSurveyTokens(template, { FirstName: firstName });
